// MUI Component to display and edit the concept paper information
import React, { useState } from "react";
import { Box, Typography, Paper, TextField, Button } from "@mui/material";

// IData interface to represent the data structure
interface IData {
    title: string;
    scope: string;
    objectives: string;
    keyword: string;
    cost: string;
    summary: string;
}


const ConceptPaperResultForm: React.FC<{ data?: IData }> = ({ data }) => {
    // If no data is passed, set default empty strings
    const [formData, setFormData] = useState<IData>({
        title: data?.title || "",
        scope: data?.scope || "",
        objectives: data?.objectives || "",
        keyword: data?.keyword || "",
        cost: data?.cost || "",
        summary: data?.summary || ""
    });

    // Handle text change
    const handleInputChange = (field: keyof IData) => (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setFormData({
            ...formData,
            [field]: event.target.value
        });
    };

    // Handle form submission (add custom logic if needed)
    const handleSubmit = () => {
        console.log("Updated Data:", formData);
    };

    if (!data) {
        return (
            <Paper elevation={3} sx={{ padding: 3, margin: 3 }}>
                <Typography variant="h6" color="error">
                    Failed to extract information from concept paper
                </Typography>
            </Paper>
        );
    }

    return (
        <Paper elevation={3} sx={{ padding: 3, margin: 3 }}>
            <Typography variant="h5" gutterBottom>
                Edit Concept Paper Information
            </Typography>

            <Box sx={{ marginBottom: 2 }}>
                <TextField
                    fullWidth
                    label="Title"
                    value={formData.title}
                    onChange={handleInputChange("title")}
                    margin="normal"
                />
            </Box>

            <Box sx={{ marginBottom: 2 }}>
                <TextField
                    fullWidth
                    label="Scope"
                    value={formData.scope}
                    onChange={handleInputChange("scope")}
                    margin="normal"
                    multiline
                    rows={4}
                />
            </Box>

            <Box sx={{ marginBottom: 2 }}>
                <TextField
                    fullWidth
                    label="Objectives"
                    value={formData.objectives}
                    onChange={handleInputChange("objectives")}
                    margin="normal"
                    multiline
                    rows={4}
                />
            </Box>

            <Box sx={{ marginBottom: 2 }}>
                <TextField
                    fullWidth
                    label="Keywords"
                    value={formData.keyword}
                    onChange={handleInputChange("keyword")}
                    margin="normal"
                    multiline
                />
            </Box>

            <Box sx={{ marginBottom: 2 }}>
                <TextField
                    fullWidth
                    label="Estimated Cost"
                    value={formData.cost}
                    onChange={handleInputChange("cost")}
                    margin="normal"
                    multiline
                />
            </Box>

            <Box sx={{ marginBottom: 2 }}>
                <TextField
                    fullWidth
                    label="Summary"
                    value={formData.summary}
                    onChange={handleInputChange("summary")}
                    margin="normal"
                    multiline
                    rows={4}
                />
            </Box>

            <Button variant="contained" color="primary" onClick={handleSubmit}>
                Save Changes
            </Button>
        </Paper>
    );
};

export default ConceptPaperResultForm;
